import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import reverse from 'lodash/reverse'
import sortBy from 'lodash/sortBy'
import styled from 'react-emotion'
import { css } from 'emotion'
import { Helmet } from 'react-helmet'

import PageHero from '../components/PageHero'
import { ReactComponent as ViewListIcon } from '../svg/view-list.svg'
import { ReactComponent as ViewTileIcon } from '../svg/view-tile.svg'
import { UnstyledLink, Card } from '../utils/styles'

const NavButton = styled('button')(({ active }) => ({
  backgroundColor: active ? 'rgba(0, 0, 0, .05)' : 'transparent',
  border: 0,
  boxSizing: 'content-box',
  color: active ? '#000' : '#606060',
  flex: 1,
  height: '1em',
  lineHeight: 1,
  padding: '1em',
  width: 'auto',

  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, .1)',
  },

  '&:focus': {
    backgroundColor: active ? 'rgba(0, 0, 0, .05)' : 'transparent',
  },

  svg: {
    fill: active ? '#000' : '#b8b8b8',
    marginLeft: 10,
    verticalAlign: 'top',
  }
}))

const videoThumbnailStyle = css({
  padding: '100% 0 0',
  height: 0,
})

class PortfolioPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = { display: 'tile' }
  }

  render() {
    const works = reverse(sortBy(
        get(this.props, 'data.allPrismicWork.edges', []),
        [(work) => work.node.data.date]
    ))
    return (
      <div css={{ paddingBottom: 30 }}>
        <Helmet>
          <title>Portfolio – Patrícia Marques</title>
          <meta name="descritpion" value="This is a select collection of the works I've been doing since I became a Makeup Artist." />
        </Helmet>
        <PageHero title="Portfolio" small="Explore my work" />
        <div
          css={{
            alignItems: 'center',
            borderBottom: '1px solid #f5f5f5',
            display: 'flex',
            justifyContent: 'center',
            margin: '0 30px',
          }}
        >
          <NavButton
            onClick={() => this.setState({ display: 'tile' })}
            active={this.state.display === 'tile'}
          >
            Grid
            <ViewTileIcon />
          </NavButton>
          <NavButton
            onClick={() => this.setState({ display: 'list' })}
            active={this.state.display === 'list'}
          >
            Cards
            <ViewListIcon />
          </NavButton>
        </div>
        <section
          css={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            padding: '30px'
          }}
        >
          {works.map((work, index) =>
            <Link
              key={index}
              to={`/work/${work.node.slugs[0]}`}
              className={UnstyledLink}
              css={{
                width: this.state.display === 'list' ? '100%' : 'calc(50% - 15px)',
              }}
            >
              <article className={Card}>
                {!isEmpty(work.node.data.gallery) && <Img
                  sizes={
                    this.state.display === 'list'
                    ? work.node.data.gallery[0].image.localFile.childImageSharp.hd
                    : work.node.data.gallery[0].image.localFile.childImageSharp.square
                  }
                />}
                {isEmpty(work.node.data.gallery) && <Img
                  className={this.state.display === 'tile' ? videoThumbnailStyle : ''}
                  sizes={
                    this.state.display === 'list'
                    ? work.node.data.videos[0].embed.thumbnail.childImageSharp.hd
                    : work.node.data.videos[0].embed.thumbnail.childImageSharp.square
                  }
                />}
                {this.state.display === 'list' &&
                  <h2>{work.node.data.title.text}</h2>
                }
              </article>
            </Link>
          )}
        </section>
      </div>
    )
  }
}

export default PortfolioPage

export const workQuery = graphql`
  query Works {
    allPrismicWork {
      edges {
        node {
          slugs
          data {
            date
            title {
              text
            }
            gallery {
              image {
                localFile {
                  childImageSharp {
                    hd: sizes(maxWidth: 1920, maxHeight: 1080, quality: 90, traceSVG: { color: "#021212" }, cropFocus: ATTENTION) {
                      ...GatsbyImageSharpSizes
                    }
                    square: sizes(maxWidth: 1920, maxHeight: 1920, quality: 90, traceSVG: { color: "#021212" }, cropFocus: ATTENTION) {
                      ...GatsbyImageSharpSizes
                    }
                  }
                }
              }
            }
            videos {
              embed {
                thumbnail: localFile {
                  childImageSharp {
                    hd: sizes(maxWidth: 1920, maxHeight: 820, quality: 90, traceSVG: { color: "#021212" }, cropFocus: CENTER) {
                      ...GatsbyImageSharpSizes
                    }
                    square: sizes(maxWidth: 761, maxHeight: 325, quality: 90, traceSVG: { color: "#021212" }, cropFocus: CENTER) {
                      ...GatsbyImageSharpSizes
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/portfolio.js